import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type QuizEditorRemoveQuestionsMutationVariables = Types.Exact<{
  data: Types.AddRemoveQuizQuestionsInput;
}>;


export type QuizEditorRemoveQuestionsMutation = { addRemoveQuizQuestions?: { success?: boolean | null } | null };


export const QuizEditorRemoveQuestionsDocument = /*#__PURE__*/ gql`
    mutation quizEditorRemoveQuestions($data: AddRemoveQuizQuestionsInput!) {
  addRemoveQuizQuestions(data: $data) {
    success
  }
}
    `;

export function useQuizEditorRemoveQuestionsMutation() {
  return Urql.useMutation<QuizEditorRemoveQuestionsMutation, QuizEditorRemoveQuestionsMutationVariables>(QuizEditorRemoveQuestionsDocument);
};